(function () {
  if (window.__fairwinCartMemoryLoaded) return;

  window.__fairwinCartMemoryLoaded = true;

  const createFallbackRoot = () => {
    const container = document.createElement('div');

    container.className = 'fairwin-cart-memory';
    container.dataset.fairwinCartSave = '';
    container.hidden = true;
    container.innerHTML = `
      <aside class="fairwin-cart-memory__dock" data-fairwin-cart-save-dock aria-live="polite">
        <span class="fairwin-cart-memory__beacon" aria-hidden="true"></span>
        <div class="fairwin-cart-memory__dock-copy">
          <span class="fairwin-cart-memory__stage" data-fairwin-cart-save-stage>Your cart is saved</span>
          <strong>
            <span data-fairwin-cart-save-count>1 item</span>
            <span aria-hidden="true"> &middot; </span>
            <span data-fairwin-cart-save-total>$0.00</span>
          </strong>
          <p data-fairwin-cart-save-nudge>Checkout is one tap away when you are ready.</p>
        </div>
        <div class="fairwin-cart-memory__dock-actions">
          <a class="fairwin-cart-memory__dock-checkout" href="/checkout" data-fairwin-cart-checkout>Checkout</a>
          <button type="button" class="fairwin-cart-memory__dock-save" data-fairwin-cart-save-open>Email me</button>
          <button type="button" class="fairwin-cart-memory__dock-close" aria-label="Close" data-fairwin-cart-save-dismiss-dock>&times;</button>
        </div>
      </aside>

      <div class="fairwin-cart-memory__modal" data-fairwin-cart-save-modal aria-hidden="true">
        <div class="fairwin-cart-memory__overlay" data-fairwin-cart-save-close></div>
        <section class="fairwin-cart-memory__dialog" role="dialog" aria-modal="true" aria-labelledby="FairwinCartSaveTitle" aria-describedby="FairwinCartSaveCopy" tabindex="-1">
          <button type="button" class="fairwin-cart-memory__close" aria-label="Close" data-fairwin-cart-save-close>&times;</button>
          <div class="fairwin-cart-memory__hero">
            <p class="fairwin-cart-memory__eyebrow">Cart rescue assistant</p>
            <h2 id="FairwinCartSaveTitle">Your FAIRWIN cart is still ready.</h2>
            <p id="FairwinCartSaveCopy" class="fairwin-cart-memory__copy">
              Finish checkout now, or send yourself the cart with a quick fit checklist so the belt does not get forgotten.
            </p>
          </div>
          <div class="fairwin-cart-memory__summary">
            <div class="fairwin-cart-memory__product">
              <div class="fairwin-cart-memory__product-media">
                <img alt="" width="96" height="96" loading="lazy" data-fairwin-cart-save-image hidden>
              </div>
              <div>
                <span data-fairwin-cart-save-product>FAIRWIN belt</span>
                <small data-fairwin-cart-save-line>Saved in your cart</small>
              </div>
            </div>
            <div class="fairwin-cart-memory__metric">
              <span>Cart total</span>
              <strong data-fairwin-cart-save-total>$0.00</strong>
            </div>
          </div>
          <div class="fairwin-cart-memory__reasons" aria-label="Checkout confidence points">
            <div><span>01</span><strong>60-day guarantee</strong><p>Try the fit with less risk.</p></div>
            <div><span>02</span><strong>Bundle value</strong><p>Add a second eligible belt to unlock 30% off.</p></div>
            <div><span>03</span><strong>Secure checkout</strong><p>Finish in under a minute.</p></div>
          </div>
          <div class="fairwin-cart-memory__actions">
            <a class="button fairwin-cart-memory__checkout" href="/checkout" data-fairwin-cart-checkout>Continue to secure checkout</a>
            <button type="button" class="fairwin-cart-memory__secondary" data-fairwin-cart-save-close>Keep shopping</button>
          </div>
          <details class="fairwin-cart-memory__email">
            <summary>Send me this cart and fit checklist instead</summary>
            <form method="post" action="/contact#FairwinCartSaveForm" id="FairwinCartSaveForm" accept-charset="UTF-8" class="fairwin-cart-memory__form">
              <input type="hidden" name="form_type" value="customer">
              <input type="hidden" name="utf8" value="">
              <input type="hidden" name="contact[tags]" value="newsletter,cart_recovery_capture,fairwin_save_cart">
              <div class="fairwin-cart-memory__field">
                <label for="FairwinCartSaveEmail">Email address</label>
                <input id="FairwinCartSaveEmail" type="email" name="contact[email]" autocomplete="email" placeholder="you@example.com" required>
              </div>
              <button type="submit" class="button fairwin-cart-memory__submit">Send my cart</button>
            </form>
          </details>
        </section>
      </div>
    `;

    container.querySelector('input[name="utf8"]').value = String.fromCharCode(10003);
    document.body.appendChild(container);

    return container;
  };

  let root = document.querySelector('[data-fairwin-cart-save]');

  if (!root) root = createFallbackRoot();

  if (!root) return;

  const dock = root.querySelector('[data-fairwin-cart-save-dock]');
  const modal = root.querySelector('[data-fairwin-cart-save-modal]');
  const dialog = root.querySelector('.fairwin-cart-memory__dialog');
  const emailInput = root.querySelector('#FairwinCartSaveEmail');
  const form = root.querySelector('form');
  const openButtons = root.querySelectorAll('[data-fairwin-cart-save-open]');
  const closeButtons = root.querySelectorAll('[data-fairwin-cart-save-close]');
  const dismissDockButtons = root.querySelectorAll('[data-fairwin-cart-save-dismiss-dock]');
  const checkoutLinks = root.querySelectorAll('[data-fairwin-cart-checkout]');
  const stageNodes = root.querySelectorAll('[data-fairwin-cart-save-stage]');
  const countNodes = root.querySelectorAll('[data-fairwin-cart-save-count]');
  const totalNodes = root.querySelectorAll('[data-fairwin-cart-save-total]');
  const nudgeNodes = root.querySelectorAll('[data-fairwin-cart-save-nudge]');
  const productNodes = root.querySelectorAll('[data-fairwin-cart-save-product]');
  const lineNodes = root.querySelectorAll('[data-fairwin-cart-save-line]');
  const imageNode = root.querySelector('[data-fairwin-cart-save-image]');

  const minute = 60 * 1000;
  const hour = 60 * minute;
  const day = 24 * hour;
  const keys = {
    cartFirstSeen: 'fairwin_cart_memory_first_seen',
    cartSignature: 'fairwin_cart_memory_signature',
    dockDismissUntil: 'fairwin_cart_memory_dock_dismiss_until',
    modalDismissUntil: 'fairwin_cart_memory_modal_dismiss_until',
    submittedUntil: 'fairwin_cart_memory_submitted_until',
    checkoutIntentUntil: 'fairwin_cart_memory_checkout_intent_until',
    hiddenAt: 'fairwin_cart_memory_hidden_at',
  };

  let currentCart = null;
  let cartHasItems = false;
  let triggersArmed = false;
  let userActiveAt = Date.now();
  let pageStartedAt = Date.now();
  let idleModalShown = false;
  let returnModalQueued = false;

  const readUntil = (key) => {
    const value = Number(window.localStorage.getItem(key) || 0);
    return Number.isFinite(value) ? value : 0;
  };

  const writeUntil = (key, duration) => {
    window.localStorage.setItem(key, String(Date.now() + duration));
  };

  const isSuppressed = () => readUntil(keys.submittedUntil) > Date.now() || readUntil(keys.checkoutIntentUntil) > Date.now();

  const isCartUiOpen = () =>
    Boolean(document.querySelector('cart-drawer.active, cart-notification.active, .cart-notification.active'));

  const isCheckoutIntent = (event) => {
    const target = event.target.closest('button[name="checkout"], a[href="/checkout"], a[href*="/checkout"]');
    return Boolean(target);
  };

  const formatMoney = (cents) => {
    const currency = currentCart?.currency || window.Shopify?.currency?.active || 'USD';

    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en', {
        style: 'currency',
        currency,
      }).format((Number(cents) || 0) / 100);
    } catch (error) {
      return `$${((Number(cents) || 0) / 100).toFixed(2)}`;
    }
  };

  const buildSignature = (cart) =>
    (cart.items || [])
      .map((item) => `${item.variant_id}:${item.quantity}`)
      .sort()
      .join('|');

  const getCartAge = () => {
    const firstSeen = Number(window.localStorage.getItem(keys.cartFirstSeen) || 0);
    return firstSeen ? Date.now() - firstSeen : 0;
  };

  const rememberCartSignature = (cart) => {
    const signature = buildSignature(cart);
    const previousSignature = window.localStorage.getItem(keys.cartSignature);

    if (signature && signature !== previousSignature) {
      window.localStorage.setItem(keys.cartSignature, signature);
      window.localStorage.setItem(keys.cartFirstSeen, String(Date.now()));
      idleModalShown = false;
    }
  };

  const clearCartMemory = () => {
    window.localStorage.removeItem(keys.cartFirstSeen);
    window.localStorage.removeItem(keys.cartSignature);
    root.hidden = true;
    root.classList.remove('is-docked', 'is-open');
    modal?.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('fairwin-cart-memory-open');
  };

  const textForCart = (cart) => {
    const itemCount = cart.item_count || 0;
    const itemLabel = `${itemCount} ${itemCount === 1 ? 'item' : 'items'}`;

    if (itemCount === 1) {
      return {
        stage: 'Do not lose the fit',
        count: itemLabel,
        nudge: 'Add 1 more eligible belt to unlock 30% off, or finish checkout now.',
        line: '1 belt waiting in your cart',
      };
    }

    return {
      stage: 'Bundle value is ready',
      count: itemLabel,
      nudge: 'Your cart is ready. Secure checkout takes less than a minute.',
      line: `${itemLabel} saved in your cart`,
    };
  };

  const renderCart = (cart) => {
    const copy = textForCart(cart);
    const firstItem = cart.items?.[0];
    const total = formatMoney(cart.total_price);

    stageNodes.forEach((node) => (node.textContent = copy.stage));
    countNodes.forEach((node) => (node.textContent = copy.count));
    totalNodes.forEach((node) => (node.textContent = total));
    nudgeNodes.forEach((node) => (node.textContent = copy.nudge));
    productNodes.forEach((node) => (node.textContent = firstItem?.product_title || 'FAIRWIN belt'));
    lineNodes.forEach((node) => (node.textContent = copy.line));

    if (imageNode && firstItem?.image) {
      imageNode.src = firstItem.image;
      imageNode.alt = firstItem.product_title || 'FAIRWIN belt in cart';
      imageNode.hidden = false;
    } else if (imageNode) {
      imageNode.hidden = true;
    }
  };

  const showDock = (reason = 'saved') => {
    if (!cartHasItems || isSuppressed() || readUntil(keys.dockDismissUntil) > Date.now()) return;
    if (isCartUiOpen()) {
      window.setTimeout(() => showDock(reason), 6500);
      return;
    }

    if (reason === 'return') {
      stageNodes.forEach((node) => (node.textContent = 'Welcome back'));
    }

    root.hidden = false;
    window.requestAnimationFrame(() => root.classList.add('is-docked'));
  };

  const openModal = (reason = 'assist') => {
    if (!cartHasItems || isSuppressed() || readUntil(keys.modalDismissUntil) > Date.now()) return;
    if (isCartUiOpen()) {
      window.setTimeout(() => openModal(reason), 8000);
      return;
    }

    if (reason === 'return') {
      stageNodes.forEach((node) => (node.textContent = 'Welcome back'));
    }

    root.hidden = false;
    modal?.setAttribute('aria-hidden', 'false');
    window.requestAnimationFrame(() => root.classList.add('is-docked', 'is-open'));
    document.documentElement.classList.add('fairwin-cart-memory-open');
    window.setTimeout(() => (dialog || emailInput)?.focus(), 120);
  };

  const closeModal = (remember = true) => {
    root.classList.remove('is-open');
    modal?.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('fairwin-cart-memory-open');

    if (remember) {
      writeUntil(keys.modalDismissUntil, 2 * day);
      writeUntil(keys.dockDismissUntil, 12 * hour);
      root.classList.remove('is-docked');
      window.setTimeout(() => {
        if (!root.classList.contains('is-docked') && !root.classList.contains('is-open')) root.hidden = true;
      }, 220);
    }
  };

  const dismissDock = () => {
    writeUntil(keys.dockDismissUntil, 8 * hour);
    root.classList.remove('is-docked');
    window.setTimeout(() => {
      if (!root.classList.contains('is-open')) root.hidden = true;
    }, 220);
  };

  const refreshCartState = (source = 'poll') => {
    fetch(`${window.routes?.cart_url || '/cart'}.js`, {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' },
    })
      .then((response) => response.json())
      .then((cart) => {
        currentCart = cart;
        cartHasItems = cart.item_count > 0;

        if (!cartHasItems) {
          clearCartMemory();
          return;
        }

        rememberCartSignature(cart);
        renderCart(cart);
        armTriggers();

        if (source === 'cart-update') {
          window.setTimeout(() => showDock('added'), 1800);
        } else if (returnModalQueued || getCartAge() > 15 * minute) {
          returnModalQueued = false;
          window.setTimeout(() => openModal('return'), 4500);
        } else {
          window.setTimeout(() => showDock('saved'), 6500);
        }
      })
      .catch(() => {});
  };

  const armTriggers = () => {
    if (triggersArmed) return;
    triggersArmed = true;

    document.addEventListener('mouseout', (event) => {
      const hasBeenOnPage = Date.now() - pageStartedAt > 12000;
      const leavingViewport = event.clientY <= 6 && !event.relatedTarget;

      if (hasBeenOnPage && leavingViewport) openModal('exit');
    });

    window.setInterval(() => {
      const idleFor = Date.now() - userActiveAt;
      const cartAge = getCartAge();

      if (!idleModalShown && idleFor > 75 * 1000 && cartAge > 45 * 1000) {
        idleModalShown = true;
        openModal('idle');
      } else if (idleFor > 35 * 1000) {
        showDock('idle');
      }
    }, 10000);

    document.addEventListener('visibilitychange', () => {
      if (document.hidden) {
        window.localStorage.setItem(keys.hiddenAt, String(Date.now()));
        return;
      }

      const hiddenAt = Number(window.localStorage.getItem(keys.hiddenAt) || 0);
      if (hiddenAt && Date.now() - hiddenAt > 5 * minute) {
        returnModalQueued = true;
        refreshCartState('return');
      }
    });
  };

  ['mousemove', 'scroll', 'keydown', 'touchstart', 'pointerdown'].forEach((eventName) => {
    document.addEventListener(
      eventName,
      () => {
        userActiveAt = Date.now();
      },
      { passive: true }
    );
  });

  openButtons.forEach((button) => button.addEventListener('click', () => openModal('manual')));
  closeButtons.forEach((button) => button.addEventListener('click', () => closeModal(true)));
  dismissDockButtons.forEach((button) => button.addEventListener('click', dismissDock));

  checkoutLinks.forEach((link) => {
    link.addEventListener('click', () => writeUntil(keys.checkoutIntentUntil, day));
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && root.classList.contains('is-open')) closeModal(true);
  });

  document.addEventListener(
    'click',
    (event) => {
      if (isCheckoutIntent(event)) writeUntil(keys.checkoutIntentUntil, day);
    },
    true
  );

  if (form) {
    form.addEventListener('submit', () => writeUntil(keys.submittedUntil, 30 * day));
  }

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, () => refreshCartState('cart-update'));
  }

  refreshCartState('load');
})();
